import { graphql, useStaticQuery } from "gatsby";

export const useTopics = () => {
    const { topics } = useStaticQuery(graphql`
        query TopicsQuery {
            topics: allContentfulTopic(sort: { name: DESC }) {
                nodes {
                    id
                    name
                    slug
                }
            }
        }
    `);

    return topics.nodes;
};
